module.exports = __webpack_public_path__ + "img/icon-list.bef321b2.svg";